module.exports = __webpack_public_path__ + "static/media/godt.e6324367.mp3";